/**
 * Nome da pessoa logada, o mesmo no header, no menu da pessoa e nas
 * configurações. O `users` do account-service não tem nome: ele vem da conta
 * pessoal (`kind: 'personal'`) entre as contas da pessoa. Sem ela, o nome da
 * primeira conta que não seja a da Mecanizou (a conta de trabalho de quem é
 * do time); sem nenhuma, o e-mail.
 */

export const PERSONAL_ACCOUNT_KIND = 'personal';
export const MECANIZOU_ACCOUNT_KIND = 'mecanizou';

type AccountLike = {
  account?: {name?: string | null; kind?: string | null} | null;
};

export type PersonLike = {
  user?: {
    email?: string | null;
    account_user?: Array<AccountLike | null> | null;
  } | null;
};

const clean = (text?: string | null) =>
  (text || '').replace(/\s+/g, ' ').trim();

const nameOf = (entry?: AccountLike | null) => clean(entry?.account?.name);

export const personName = (person?: PersonLike | null): string => {
  const accounts = person?.user?.account_user || [];
  const personal = accounts.find(
    (entry) =>
      entry?.account?.kind === PERSONAL_ACCOUNT_KIND && Boolean(nameOf(entry))
  );
  if (personal) return nameOf(personal);
  const other = accounts.find(
    (entry) =>
      entry?.account?.kind !== MECANIZOU_ACCOUNT_KIND && Boolean(nameOf(entry))
  );
  if (other) return nameOf(other);
  return clean(person?.user?.email);
};

/** Iniciais do avatar: primeira e última palavra; do e-mail, a primeira letra. */
export const personInitials = (name: string): string => {
  const text = clean(name);
  if (!text) return '';
  if (text.includes('@')) return text.charAt(0).toUpperCase();
  const words = text.split(' ');
  const first = words[0].charAt(0);
  const last = words.length > 1 ? words[words.length - 1].charAt(0) : '';
  return `${first}${last}`.toUpperCase();
};
